<div class="row" *ngIf="companyDetails">
    <div class="col-6">
        <h1>{{ companyDetails.name }}</h1>
    </div>
    <div class="col-6 ">

    </div>
</div>


<!--app-add-company-->
<div class="row" *ngIf="companyDetails">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header">
                <div class="row align-items-center card-header">
                    <div class="col-6">
                        <h5>Detalles de Compañía</h5>
                    </div>
                    <div class="col-6 company-action-group" >
                        <div class="company-action-btn"><app-remove-company [companyData]="companyDetails"></app-remove-company></div>
                        <div class="company-action-btn edit"><app-edit-company [companyData]="companyDetails"></app-edit-company></div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <p><b>Dirección</b></p>
                        <p>{{  companyDetails.address1}}, {{  companyDetails.address2 }}<br/>
                            {{  companyDetails.city }} {{  companyDetails.state }} {{  companyDetails.zip }}</p>
                    </div>
                    <div class="col-md-2">
                        <p><b>Teléfono</b></p>
                        <p>{{  companyDetails.phone }}</p>
                    </div>
                    <div class="col-md-2">
                        <p><b>Email</b></p>
                        <p>{{  companyDetails.email }}</p>
                    </div>
                    <div class="col-md-3">
                        <p><b>Contacto</b></p>
                        <p><b>{{  companyDetails.contact }}</b><br/>
                            {{  companyDetails.contactEmail }}<br/>
                            {{  companyDetails.contactPhone }}
                        </p>
                    </div>
                    <div class="col-md-2">
                        <p><b>Estatus</b></p>
                        <p><span style="color:rgb(62, 145, 62)" *ngIf="companyDetails.active">Active</span>
                            <span style="color:rgb(212, 59, 59)" *ngIf="!companyDetails.active">Inactive</span>
                        </p>
                    </div>
                    <div class="col-md-2">
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <div class="card">
            <div class="card-header">
                <div class="row align-items-center card-header">
                    <div class="col-6">
                        <h5>Sucursales</h5>
                    </div>
                    <div class="col-6">
                        <app-add-branches [companyId]="companyId"></app-add-branches>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Sucursal</th>
                            <th scope="col">Dirección</th>
                            <th scope="col">Teléfono</th>
                            <th scope="col">Email</th>
                            <th scope="col">Contacto</th>
                            <th scope="col">Estatus</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let branch of branches">
                            <td>{{ branch.name }}</td>
                            
                            <td>{{ branch.address1 }}, {{ branch.address2 }}<br/>{{ branch.city }} {{ branch.state }} {{ branch.zip }}</td>
                            <td>{{ branch.phone}}</td>
                            <td>{{ branch.email }}</td>
                            <td><b>{{ branch.contact }}</b><br/>{{ branch.contactPhone }}<br/>{{ branch.contactEmail }}</td>
                            <td *ngIf="branch.active">Active</td>
                            <td *ngIf="!branch.active">Inactive</td>
                            <td class="action-btn">
                                <button type="button" (click)="branchDetails(branch)" class="btn btn-secondary edit-btn" data-toggle="modal" data-target="#editBranchModal">Editar</button><br>
                                <button type="button" (click)="branchDetails(branch)" class="btn btn-danger" data-toggle="modal" data-target="#removeBranchModal">Remover</button></td>
                          </tr>
                        </tbody>
                      </table>
                </div>
            </div>
        </div>
    </div>
</div>

<app-edit-branch [branchData]="branchEdit"></app-edit-branch>

<app-remove-branch [branchData]="branchEdit"></app-remove-branch>

<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>